export default 
    {
    "Mobiles": [
        "Apple",
        "Sony",
        "HTC",  
        "Samsung"
        ],
   
    "Accessories": [
        "HandFree",
        "Chargers",
        "Bettries"
        ]
    };


// WEBPACK FOOTER //
// ./src/data/mobiles.js